import type { EscalationRiskTier } from "@remi/enums/escalation-risk-tier";
import type { EscalationStage } from "@remi/enums/escalation-stage";
import type { EscalationSubStatus } from "@remi/enums/escalation-sub-status";

export const EscalationStageDisplayNames = {
  NOT_CONTACTED: "Triage",
  PENDING_CONTACT: "Pending contact",
  PENDING_RESOLUTION: "Pending resolution",
  RESOLVED_PENDING_COMPLETION: "Pending completion",
  COMPLETION: "Resolved",
  DISMISSED: "Cancelled",
} as const satisfies Record<EscalationStage, string>;

export const EscalationRiskTierDisplayNames = {
  HEALTHY: "Healthy",
  WATCH: "Watch",
  AT_RISK: "At risk",
  CRITICAL: "Critical",
} as const satisfies Record<EscalationRiskTier, string>;

export const EscalationSubStatusDisplayNames = {
  WAITING_ON_REMI: "Waiting on Remi",
  WAITING_ON_SUNRUN: "Waiting on partner",
  WAITING_ON_CONTRACTOR: "Waiting on contractor",
  WAITING_ON_CUSTOMER: "Waiting on customer",
  WAITING_ON_THIRD_PARTY: "Waiting on third party",
  DATE_SET: "Work scheduled",
  WAITING_ON_FINAL_INSPECTION: "Inspection pending",
} as const satisfies Record<EscalationSubStatus, string>;
